import Dialog from "@/components/Dialog";
import Button from "@/components/Button";
import classNames from "classnames";

interface RemovePersonDialogProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  isLoading?: boolean;
  personName?: string;
  roleTitle?: string;
}

export function RemovePersonDialog({
  open,
  onClose,
  onConfirm,
  isLoading = false,
  personName = "this person",
  roleTitle
}: RemovePersonDialogProps) {
  return (
    <Dialog
      open={open}
      onClosed={onClose}
      headline="Remove Person Permissions"
      actions={
        <>
          <Button variant="text" onClick={onClose} disabled={isLoading}>
            Cancel
          </Button>
          <Button
            onClick={onConfirm}
            disabled={isLoading}
            theme="error"
            icon={isLoading ? "progress_activity" : "delete"}
            iconClassName={classNames(isLoading && "animate-spin w-6 h-6 !block")}
            trailingIcon={false}
          >
            Remove
          </Button>
        </>
      }
    >
      <p>
        Are you sure you want to remove {personName}&apos;s {roleTitle ? `${roleTitle} permissions` : "permissions"}{" "}
        from this facility&apos;s operations?
      </p>
    </Dialog>
  );
}
